import React, { createContext, useCallback, useState } from "react"
import { EntityModalType } from "../types"

export type ModalsState = {
  isOpened: boolean
  type: EntityModalType
  entity: string
  subpage?: string
  id?: string | string[]
  record?: any
  result?: any
  ids?: Record<string, string>
  // Additional properties for bulk license actions
  isSelectAll?: boolean
  useFilters?: boolean
  totalCount?: number
  entityName?: string
  filters?: Record<string, any>
  actionType?: "assign" | "unassign"
}

export const INITIAL_MODALS_STATE: ModalsState = {
  isOpened: false,
  type: null,
  entity: null,
  subpage: null,
  id: null,
  result: null,
  ids: null
}

type ModalStateContextType = {
  modalsState: ModalsState
  onAddModal: (value: ModalsState) => void
  onCloseModal: (result?: boolean, entity?: string) => void
  onResetModalState: () => void
}

export const ModalStateContext = createContext<ModalStateContextType>(null)

const ModalStateProvider: React.FC = ({ children }) => {
  const [modalsState, setModalsState] =
    useState<ModalsState>(INITIAL_MODALS_STATE)

  const onAddModal = useCallback(value => {
    setModalsState(value)
  }, [])

  const onCloseModal = useCallback((result: boolean, entity?: string) => {
    setModalsState({
      ...INITIAL_MODALS_STATE,
      result,
      ...(!!entity ? { entity } : {})
    })
  }, [])

  const onResetModalState = useCallback(() => {
    setModalsState({
      ...INITIAL_MODALS_STATE
    })
  }, [])

  return (
    <ModalStateContext.Provider
      value={{ modalsState, onAddModal, onCloseModal, onResetModalState }}
    >
      {children}
    </ModalStateContext.Provider>
  )
}

export default ModalStateProvider
